import styled from 'styled-components';

import { FallbackImageImagePanoramic } from '@xing-com/illustrations';
import { Image } from '@xing-com/image';

const StyledImage = styled(Image)`
  width: 100%;
  object-fit: cover;
  aspect-ratio: 16/9;
`;

const StyledFallbackImage = styled(FallbackImageImagePanoramic)`
  object-fit: cover;
  aspect-ratio: 16/9;
`;

export const Styled = {
  Image: StyledImage,
  FallbackImage: StyledFallbackImage,
};
